import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
  reportParticipants: {},
}

export const getters = {}

export const mutations = {
  REPORTPARTICIPANTS(state, request) {
    state.reportParticipants = request
  },
}

export const actions = {
  init({ state, dispatch }) {},

  fetchReportParticipantsAllData(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/api/participants/${query}`)
      .then((response) => {
        const request = response.data
        context.commit('REPORTPARTICIPANTS', request)
        return request
      })
  },
}
